import { otherProductReducer } from "app/otherProductReducer";
import AddToCartButton from "components/AddToCartButton";
import BillingCycleOptions from "components/BillingCycleOptions";
import CardWrapper from "components/CardWrapper";
import {
  addToCart,
  changeProductFromCart,
} from "features/common/layouts/cartSlice";
import {
  getProduct,
  selectProduct,
} from "features/common/products/productsSlice";
import { formatIDR, useQuery } from "helpers/utils";
import MainLayouts from "layouts/MainLayouts";
import { useEffect, useReducer, useRef, useState } from "react";
import { Placeholder } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { notifySuccess } from "components/ToastMessage";
import { setOrderParams } from "features/common/layouts/cartSlice";
import { useLocation } from "react-router-dom";

const OtherProduct = () => {
  const query = useQuery();
  const location = useLocation();
  const dispatch = useDispatch();
  const count = useRef(0);
  const { productsList } = useSelector((state) => state.cart);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pid = params.get("pid");
    const billingcycle = params.get("billingcycle");
    dispatch(setOrderParams({ pid, billingcycle }));
  }, [location.search, dispatch]);

  const [termin, setTermin] = useState("annually");
  const [priceByTermin, setPriceByTermin] = useState(0);
  const [originalPriceByTermin, setOriginalPriceByTermin] = useState(0);
  const isMonitimePid = +query.pid === 1146;

  const currentProduct = useSelector(selectProduct);
  const [otherProduct, setOtherProduct] = useReducer(otherProductReducer, {
    pid: +query.pid || 921,
    price: {},
    productDetails: null,
  });
  const { pid, productDetails } = otherProduct;
  const { current, status } = currentProduct;

  useEffect(() => {
    dispatch(getProduct(pid));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (current) {
      count.current += 1;
    }
    setOtherProduct({
      type: "SET_PRODUCT_DETAIL",
      payload: current,
    });
    setOtherProduct({
      type: "SET_PRODUCT_PRICE",
      payload: current?.pricing?.IDR,
    });
    setOtherProduct({
      type: "SET_PRICE_AND_CYCLE",
      payload: { price: +priceByTermin, billingcycle: termin },
    });
  }, [current, termin, priceByTermin]);

  useEffect(() => {
    switch (termin) {
      case "triennially":
        setPriceByTermin(otherProduct?.price?.triennially);
        setOriginalPriceByTermin(isMonitimePid ? (parseFloat(otherProduct?.price?.triennially) || 0) + 5000 : 0);
        break;
      case "biennially":
        setPriceByTermin(otherProduct?.price?.biennially);
        setOriginalPriceByTermin(isMonitimePid ? (parseFloat(otherProduct?.price?.biennially) || 0) + 5000 : 0);
        break;
      case "annually":
        setPriceByTermin(otherProduct?.price?.annually);
        setOriginalPriceByTermin(isMonitimePid ? (parseFloat(otherProduct?.price?.annually) || 0) + 5000 : 0);
        break;
      case "quarterly":
        setPriceByTermin(otherProduct?.price?.quarterly);
        setOriginalPriceByTermin(isMonitimePid ? (parseFloat(otherProduct?.price?.quarterly) || 0) + 5000 : 0);
        break;
      case "semiannually":
        setPriceByTermin(otherProduct?.price?.semiannually);
        setOriginalPriceByTermin(isMonitimePid ? (parseFloat(otherProduct?.price?.semiannually) || 0) + 5000 : 0);
        break;
      case "monthly":
        setPriceByTermin(otherProduct?.price?.monthly);
        setOriginalPriceByTermin(isMonitimePid ? (parseFloat(otherProduct?.price?.monthly) || 0) + 5000 : 0);
        break;
      default:
        setPriceByTermin(0);
        setOriginalPriceByTermin(0);
        break;
    }
  }, [termin, dispatch, otherProduct, pid, isMonitimePid]);

  const terminHandle = (e) => {
    const newTermin = e.target.value;
    setTermin(newTermin);
    
    // Update productDetails dengan billing cycle baru jika produk sudah ada di cart
    const checkProduct = productsList.find((list) => list.pid === +query.pid);
    if (checkProduct && productDetails) {
      // Update productDetails dengan termin baru
      setOtherProduct({
        type: "SET_PRICE_AND_CYCLE",
        payload: { 
          price: otherProduct?.price?.[newTermin] || 0, 
          billingcycle: newTermin 
        },
      });
    }
  };

  const addToCartHandler = () => {
    if (status === "idle" && productDetails) {
      dispatch(addToCart(productDetails));
      notifySuccess("Produk berhasil ditambakan ke keranjang.");
    }
  };

  useEffect(() => {
    const checkProduct = productsList.find((list) => list.pid === query.pid);
    if (productDetails && checkProduct) {
      dispatch(changeProductFromCart(productDetails));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDetails, dispatch]);

  // Update cart saat termin atau harga berubah
  useEffect(() => {
    const checkProduct = productsList.find((list) => list.pid === +query.pid);
    if (checkProduct && productDetails && status === "idle") {
      // Pastikan billing cycle dan harga di cart match dengan state current
      if (checkProduct.billingcycle !== termin || checkProduct.price !== priceByTermin) {
        const updatedProductDetails = {
          ...productDetails,
          billingcycle: termin,
          price: priceByTermin
        };
        dispatch(changeProductFromCart(updatedProductDetails));
      }
    }
  }, [termin, priceByTermin, productDetails, productsList, dispatch, query.pid, status]);

  return (
    <MainLayouts summary={false}>
      <CardWrapper title="Konfigurasi Layanan">
        <div className="row">
          <div className="col-12">
            {status === "idle" && (
              <div className="fw-bold text-qw-primary mb-3 h5 product-title">
                {productDetails?.name}
              </div>
            )}
            {status === "loading" && (
              <Placeholder as="div" animation="glow">
                <Placeholder xs={8} bg="danger" />
              </Placeholder>
            )}
          </div>
        </div>
        <div className="col-12 text-end">
          {status === "idle" && (
            <>
              {isMonitimePid ? (
                <div className="d-flex flex-column align-items-end">
                  <p className="fw-bold mb-0 d-inline-block text-secondary">
                    <del>{formatIDR(originalPriceByTermin)}</del>
                  </p>
                  <div className="d-flex align-items-center">
                    <span className="badge btn-cta p-2 me-2">
                      PROMO!
                    </span>
                    <div className="fw-bold text-qw-primary h5 mb-0">
                      {formatIDR(priceByTermin ?? 0)}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <label htmlFor="price" className="d-inline">
                    Harga:
                  </label>
                  <div className="fw-bold ms-3 mb-0 d-inline">
                    {formatIDR(priceByTermin ?? 0)}
                  </div>
                </>
              )}
            </>
          )}
          {status === "loading" && (
            <Placeholder as="div" animation="glow">
              <Placeholder xs={2} />
            </Placeholder>
          )}
        </div>
        <div className="col-12">
          {status === "idle" && (
            <BillingCycleOptions
              termin={termin}
              terminHandle={terminHandle}
              productsItem={otherProduct}
            />
          )}
        </div>
        <AddToCartButton onClick={addToCartHandler} />
      </CardWrapper>
    </MainLayouts>
  );
};

export default OtherProduct;
